import { atom } from "recoil";

export const searchKeywords = atom<string>({
  key: "searchKeywords",
  default: "",
});
